import { i18n } from '../../lang/i18n';
import ScrollToTop from "../../components/ScrollToTop";

interface Props
{
    recipe: any
}
export default function RecipeScreen(props: Props)
{
    const method = props.recipe
    return (
        <div className="container recipe">
            <ScrollToTop />
            <div style={{ flex: 1 }}>
                <div className="recipe-title">
                    {method.name}
                </div>
                <div className="recipe-image" style={{ backgroundImage: 'url("' + method.photo.url250 + '")' }}>
                </div>
                <div className="recipe-title" style={{ fontSize: 25, margin: 15, textAlign: 'center' }}>
                    {i18n.RecipeScreen.Ingredients}
                </div>
                <div style={{ padding: 20, marginBottom: 20 }}>
                    {method.ingredients.map((item: any, index: number) => (
                        <div key={index} className="recipe-step"
                            style={{
                            }}>
                            <div className="recipe-step-number">{index + 1}</div>
                            <div className="recipe-step-text">{item}</div>
                        </div>
                    ))}
                </div>
                <div className="recipe-title" style={{ fontSize: 25, margin: 15, textAlign: 'center' }}>
                    {i18n.RecipeScreen.Steps}
                </div>
                <div style={{ padding: 20, marginBottom: 20 }}>
                    {method.steps.map((item: any, index: number) => (
                        <div key={index} className="recipe-step"
                            style={{
                            }}>
                            <div className="recipe-step-number">{index + 1}</div>
                            <div className="recipe-step-text">{item}</div>
                        </div>
                    ))}
                </div>
                {method.description.length > 0 && <div className="recipe-title" style={{ fontSize: 25, margin: 15, textAlign: 'center' }}>
                    {i18n.RecipeScreen.Notes}
                </div>}
                <div style={{ padding: 20, marginBottom: 10 }}>
                    {method.description.map((item: any, index: number) => (
                        <label key={index} style={{ flex: 1, flexDirection: 'column', fontSize: 15 }}>{item}</label>
                    ))}
                </div>
            </div>
        </div>
    )
}